<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" :class="mode" to="/">
                <span class="navbar-brand-full">
                    <i class="fa-duotone fa-coins fa-lg fa-fw gx-logo"></i>
                    <span class="gx-logo-text">GOLDEXCHANGE</span>
                </span>
                <span class="navbar-brand-minimized">
                    <i class="fa-duotone fa-coins fa-lg gx-logo"></i>
                </span>
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />

            <b-col>
                <HeaderSearch></HeaderSearch>
            </b-col>
            <b-col class="ml-auto">
                <HeaderMarket></HeaderMarket>
            </b-col>

            <b-navbar-nav>
                <TechnologyIssue></TechnologyIssue>
                <HeaderDropdownNotifications class="MainNotificationDropdown"></HeaderDropdownNotifications>
                <HeaderDropdownAccount></HeaderDropdownAccount>
                <HeaderDropdown right no-caret class="mr-1">
                    <template slot="header">
                        <video-streamer-status></video-streamer-status>
                        <vue-qz-tray-status></vue-qz-tray-status>
                    </template>
                    <template slot="dropdown">
                        <b-dropdown-header>
                            <div>Video: <strong>Connected</strong></div>
                            <div>Scale/Printer: <strong>{{ this.$qz.connected ? 'Connected' : 'Not Connected' }}</strong></div>
                        </b-dropdown-header>
                    </template>
                </HeaderDropdown>
            </b-navbar-nav>

            <div class="position-relative">
                <AsideToggler class="d-none d-lg-block"/>
                <b-badge v-if="profile.flag_count" class="flag-alert-badge" pill variant="danger">
                    <span v-if="$store.getters.flagAsideUpdating"><i class="fa-regular fa-spinner-third fa-spin fa-fw"></i></span>
                    <span v-else>{{ profile.flag_count }}</span>
                </b-badge>
            </div>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <transition name="slide-fade">
                <SidebarHeader class="p-0" v-if="this.$store.getters.isOrderLoaded && this.$store.getters.activeOrder.customer">
                    <div class="text-left">
                        <div class="bg-warning font-weight-bold py-1 order-info-panel">
                            <div class="">{{ this.$store.getters.activeOrder.customer.full_name | titleCase }}
                                <label class="mb-0">{{ this.$store.getters.activeOrder.status_name || this.$store.getters.activeOrder.status.status }}</label>
                            </div>
                            <div class="">
                                <span><i class="fa-solid fa-fw mr-1 fa-user fa-fw"></i>{{ this.$store.getters.activeOrder.customer.id }}</span>
                                <span class="ml-3"><i class="fa-solid fa-fw mr-1 fa-box fa-fw"></i> {{ this.$store.getters.activeOrder.id }}</span>
                            </div>

                        </div>

                        <template v-if="this.$route.name == 'kit-view-index' ">
                            <ul class="list-unstyled work-space-links">
                                <li><a href="#flags" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-flag"></i> Flags</a></li>
                                <li><a href="#order" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-box"></i> Order</a></li>
                                <li v-if="this.$store.getters.activeOrder.currentOffer">
                                    <a href="#processing" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-boxes"></i> Processing</a>
                                </li>
                                <li><a href="#payment" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-money-bill-alt"></i> Payments</a></li>
                                <li v-if="this.$store.getters.activeOrder.returned_at != null">
                                    <a href="#returns" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-exchange"></i> Returns</a>
                                </li>
                                <li><a href="#history" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-history"></i> History</a></li>
                            </ul>
                        </template>

                        <template v-else>
                            <ul class="list-unstyled work-space-links">
                                <li><a href="#" @click="goToKitsViewSection('flags')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-flag"></i> Flags</a></li>
                                <li><a href="#" @click="goToKitsViewSection('order')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-box"></i> Order</a></li>
                                <li v-if="this.$store.getters.activeOrder.currentOffer">
                                    <a href="#" @click="goToKitsViewSection('processing')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-boxes"></i> Processing</a>
                                </li>
                                <li><a href="#" @click="goToKitsViewSection('payment')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-money-bill-alt"></i> Payments</a></li>
                                <li v-if="this.$store.getters.activeOrder.returned_at != null">
                                    <a href="#" @click="goToKitsViewSection('returns')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-exchange"></i> Returns</a>
                                </li>
                                <li><a href="#" @click="goToKitsViewSection('history')" v-smooth-scroll class="nav-item  "><i class="fa-solid fa-fw mr-1 fa-history"></i> History</a></li>
                            </ul>
                        </template>

                    </div>
                </SidebarHeader>
                </transition>
                <SidebarNav :navItems="navByRole"></SidebarNav>
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main">
                <div class="container-fluid pt-4 pb-4 h-100">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside>
                <!--aside-->
                <DefaultAside/>
            </AppAside>
        </div>
        <!--        <AppFooter class="justify-content-between">-->
        <!--            <div>-->
        <!--                GoldExchange-->
        <!--                <span class="ml-1">&copy; 2019 Beyond79.</span>-->
        <!--            </div>-->
        <!--        </AppFooter>-->

        <add-flag-modal ref="addFlagModal"></add-flag-modal>
        <edit-flag-modal ref="editFlagModal"></edit-flag-modal>
    </div>
</template>

<script>
    import nav from '@/_nav.js';
    import {
        BROADCAST_INIT,
        BROADCAST_DISCONNECT, BROADCAST_CONNECTED, USER_SUCCESS, BROADCAST_CONNECT, NOTIFICATION_ADD, NOTIFICATION_REMOVE, SYNC_USER,
    } from '../store/actions';
    import {
        Aside as AppAside,
        AsideToggler,
        Header as AppHeader,
        HeaderDropdown,
        Sidebar as AppSidebar,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
    } from '@coreui/vue';
    import DefaultAside from './DefaultAside';
    import HeaderDropdownNotifications from '../components/HeaderDropdownNotifications';
    import HeaderDropdownAccount from '../components/HeaderDropdownAccount';
    import HeaderMarket from '@/components/HeaderMarket';
    import HeaderSearch from '../components/HeaderSearch';
    import VideoStreamerStatus from '@/plugins/video-streamer/components/video-streamer-status';
    import HeaderDropdownFlags from '@/components/HeaderDropdownFlags';
    import TechnologyIssue from '@/components/TechnologyIssue';
    import {each, find} from 'lodash';
    import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue';

    export default {
        name: 'DefaultContainer',
        components: {
            AppAside,
            AsideToggler,
            DefaultAside,
            HeaderDropdownFlags,
            HeaderMarket,
            VideoStreamerStatus,
            AppHeader,
            AppSidebar,
            HeaderDropdown,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            HeaderDropdownNotifications,
            HeaderDropdownAccount,
            HeaderSearch,
            TechnologyIssue,
        },
        data() {
            return {
                navByRole: [],
                oldOrder: null,
                mode: 'class-' + process.env.NODE_ENV,
            };
        },
        beforeCreate() {
            this.$store.commit('setActiveFlag', null);
            this.$store.commit('setAddFlag', null);
            this.$store.commit('commitFlag', null);
        },
        beforeDestroy() {
            this.navByRole = [];
            if(this.orderUpdated) {
                this.leaveBroadcastChannel();
            }
        },
        beforeMount() {

        },
        mounted() {
            if (!this.$store.getters.isProfileLoaded) {
                this.$store.subscribe((mutation) => {
                    if (mutation.type === USER_SUCCESS) {
                        console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                        this.setNavItems();
                    }
                });
            } else {
                this.setNavItems();
            }
            if (this.orderUpdated) {
                this.joinBroadcastChannel();
            }
        },

        methods: {
            joinBroadcastChannel: function () {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Flag.Order.' + this.orderUpdated.id + ' channel from HeaderSearch.');
                    this.oldOrder = this.orderUpdated;
                    this.$echo.channel('App.Flag.Order.' + this.orderUpdated.id)
                        .listen('FlagWasCreated', this.flagUpdatedCall)
                        .listen('FlagWasUpdated', this.flagUpdatedCall)
                        .listen('FlagWasDeleted', this.flagUpdatedCall)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Flag.Customer.' + this.orderUpdated.customer.id + ' channel from HeaderSearch.');
                    this.$echo.channel('App.Flag.Customer.' + this.orderUpdated.customer.id)
                        .listen('FlagWasCreated', this.flagUpdatedCall)
                        .listen('FlagWasUpdated', this.flagUpdatedCall)
                        .listen('FlagWasDeleted', this.flagUpdatedCall)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                });
            },
            leaveBroadcastChannel: function() {
                this.$echo.leaveChannel('App.Flag.Order.' + this.oldOrder.id);
                this.$echo.leaveChannel('App.Flag.Customer.' + this.oldOrder.customer.id);
            },
            flagUpdatedCall: function(container) {
                if(container.flag) {
                    this.$nextTick(()=> {
                        this.$store.commit('commitFlag', container.flag);
                        this.$forceUpdate();
                    });
                    console.log("BROADCAST CHANNEL UPDATE CONTAINER",container);
                }
            },
            goToKitsViewSection(kitViewSection) {
                let orderId = this.$store.getters.activeOrder.id;
                let basePath = '/kit/view/';
                this.$router.push(`${basePath}${orderId}#${kitViewSection}`);
            },
            removeItem(id) {
                this.deleted[id] = true;
                this.$http.post('/users/flags/', {id: id}).then((payload) => {
                    this.items = payload.data.data;
                });
            },
            setNavItems() {
                this.navByRole = [];
                this.navByRole = setDefaultNav();
                if (this.$store.getters.getProfile.roles) {
                    let userRoles = this.$store.getters.getProfile.roles.data;
                    let knowledgeBaseLinkHidden = true;
                    each(this.navByRole, (item) => {
                        item.class = 'd-none';
                        each(userRoles, (role) => {
                            if (role.name === 'Super Admin' || role.name === 'B79 Admin' || find(item.roles, function(o) { return o === 'all' || o === role.name; })) {
                                item.class = '';
                            }
                            if (item.name === 'Knowledge Base' && item.class === '') {
                                item.class = 'mt-auto';
                                knowledgeBaseLinkHidden = false;
                            }
                            if (item.name === 'Settings' && item.class === '' && knowledgeBaseLinkHidden) {
                                item.class = 'mt-auto';
                            }
                            if (item.name === 'Knowledge Base' || item.name === 'Pricing' || item.name === 'Admin Tools' || item.name === 'Settings') {
                                item.class += ' nav-item-settings';
                            }
                        });
                    });
                }
            }
        },

        computed: {
            profile: function () {
                return this.$store.getters.getProfile;
            },
            orderUpdated: function() {
                return this.$store.getters.activeOrder;
            }
        },

        watch: {
            profile: function() {
                console.log('set nav from watcher');
                this.setNavItems();
            },
            orderUpdated: function(order) {
                if(this.oldOrder) {
                    this.leaveBroadcastChannel();
                }
                if(order) {
                    this.joinBroadcastChannel();
                }
            }
        }
    };

    function setDefaultNav () {
        return Object.assign([], nav.items);
    }
</script>

<style scoped>
    .flag-alert-badge {
        position: absolute;
        right: 5px;
        top: -5px;
    }

    .class-development {
        background-color: #e30000 !important;
    }
    .class-testing {
        background-color: #ff7300 !important;
    }
    .class-uat {
        background-color: #00deff !important;
    }
    .class-staging {
        background-color: #009926 !important;
    }
    .class-production {
    }

</style>
